// action enums
import { FeedbackScreenEnum, IScreenData } from './feedback-data.data';

export enum ActionsEnum {
  FETCH_SCREEN = 'FETCH_SCREEN',
  SET_SCREEN = 'SET_SCREEN',
  SEND_FEEDBACK = 'SEND_FEEDBACK', // Latest API version
  SEND_FEEDBACK_200 = 'SEND_FEEDBACK_200', // 2.0.0 API version
  SEND_FEEDBACK_SUCCESS = 'SEND_FEEDBACK_SUCCESS',
  SEND_FEEDBACK_FAILURE = 'SEND_FEEDBACK_FAILURE',
  HIDE_FEEDBACK_CARD_FOR_FEATURE = 'HIDE_FEEDBACK_CARD_FOR_FEATURE',
}

// action payload definitions
export interface IFeedback200 {
  screen: FeedbackScreenEnum;
  screenProperties?: string;
  comment: string;
  userEmail?: string;
}

export interface IFeedback {
  screen: FeedbackScreenEnum;
  screenProperties?: string;
  feedback: IFeedbackResponseItem[];
}

// interface for feedback API request payload
export interface IFeedbackResponseItem {
  item_id: string;
  value: string | string[] | number | boolean | null;
}

export interface IHideFeedbackCard {
  featureName: string;
  accountId: string;
}

export interface IErrorPayload {
  error: [string, any] | Error;
}

export interface IScreenIdPayload {
  screenId: FeedbackScreenEnum;
}

// action definitions
export interface SendFeedback {
  type: ActionsEnum.SEND_FEEDBACK;
  payload: IFeedback;
}

export interface SendFeedback200 {
  type: ActionsEnum.SEND_FEEDBACK_200;
  payload: IFeedback200;
}

export interface SendFeedbackSuccess {
  type: ActionsEnum.SEND_FEEDBACK_SUCCESS;
}

export interface SendFeedbackFailure {
  type: ActionsEnum.SEND_FEEDBACK_FAILURE;
  payload: IErrorPayload;
}

export interface HideFeedbackCardForFeature {
  type: ActionsEnum.HIDE_FEEDBACK_CARD_FOR_FEATURE;
  payload: IHideFeedbackCard;
}

export interface FetchScreen {
  type: ActionsEnum.FETCH_SCREEN;
  payload: IScreenIdPayload;
}

export interface SetScreen {
  type: ActionsEnum.SET_SCREEN;
  payload: IScreenData;
}

// action creators
export const sendFeedback = ({
  screen,
  screenProperties,
  feedback,
}: IFeedback): SendFeedback => ({
  type: ActionsEnum.SEND_FEEDBACK,
  payload: {
    screen,
    screenProperties,
    feedback,
  },
});

export const sendFeedback200 = ({
  screen,
  screenProperties,
  comment,
  userEmail,
}: IFeedback200): SendFeedback200 => ({
  type: ActionsEnum.SEND_FEEDBACK_200,
  payload: {
    screen,
    screenProperties,
    comment,
    userEmail,
  },
});

export const sendFeedbackSuccess = (): SendFeedbackSuccess => ({
  type: ActionsEnum.SEND_FEEDBACK_SUCCESS,
});

export const sendFeedbackFailure = (
  error: [string, any] | Error
): SendFeedbackFailure => ({
  type: ActionsEnum.SEND_FEEDBACK_FAILURE,
  payload: {
    error,
  },
});

export const hideFeedbackCardForFeature = (
  featureName: string,
  accountId: string
): HideFeedbackCardForFeature => ({
  type: ActionsEnum.HIDE_FEEDBACK_CARD_FOR_FEATURE,
  payload: {
    featureName,
    accountId,
  },
});

export const fetchScreen = (screenId: FeedbackScreenEnum): FetchScreen => ({
  type: ActionsEnum.FETCH_SCREEN,
  payload: {
    screenId,
  },
});

export const setScreen = (
  screenId: FeedbackScreenEnum,
  data: any
): SetScreen => ({
  type: ActionsEnum.SET_SCREEN,
  payload: {
    [screenId]: data,
  },
});
